const components = require.context("./", false, /\.vue$/);

export default (Vue) => {
  components.keys().map((item) => {
    Vue.component(item.slice(2, -4), components(item).default);
  });
};
